module.exports = __webpack_public_path__ + "static/media/tachometer-average.d337e66e.svg";